import { Backdrop, CircularProgress } from '@mui/material';

interface LoaderBackdropProps {
  message?: string;
}

const LoaderBackdrop = ({ message }: LoaderBackdropProps) => (
  <Backdrop
    sx={(theme) => ({
      backgroundColor: theme.palette.background.default,
      zIndex: theme.zIndex.drawer + 1,
    })}
    open={true}
  >
    <div className='flex flex-col items-center gap-3'>
      <CircularProgress color={'primary'} />
      {message ? (
        <p className='text-sm text-gray-700 font-medium'>{message}</p>
      ) : null}
    </div>
  </Backdrop>
);

export default LoaderBackdrop;
